// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"12c00412","349":"2d765739","566":"531aafe1","753":"628307c0","923":"c8b06b6c"}[chunkId] + ".chunk.js";
};